import { BillingPage } from '@/pages/billing';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/billing')({
	component: BillingPage,
});
